<template>
  <div class="lm-application-engine">
    <div class="title">MoPaaS 大模型应用引擎</div>
    <div class="box">
      <div class="content">MoPaaS 大模型应用引擎基于用户私有大模型或第三方大模型，提供知识增强生成 (RAG) 和智能体 (Agent) 能力，用户可以低代码轻松快捷地构建和运行大模型AI原生应用。</div>
      <img src="../assets/images/lm-engine.png"/>
      <div class="content2">大模型应用引擎：基于 RAG 的大模型 AI 应用</div>
    </div>
  </div>
</template>

<script>
	export default {
		name: 'ApplicationScope',
		data() {
      return {}
    }
	}
</script>

<style>

	@media (min-width:992px) {
    .lm-application-engine {
      background: #FFFFFF;
      padding: 120px 0;
    }

    .lm-application-engine .title {
      margin: 0 auto;
      height: 33px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #303133;
      line-height: 33px;
      text-align: center;
      font-style: normal;
    }

		.lm-application-engine .box {
      width: 1400px;
      margin: 40px auto 0;
		}

		.lm-application-engine .box .content {
      margin: 0 auto;
      height: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #303133;
      line-height: 20px;
      text-align: center;
      font-style: normal;
    }
    .lm-application-engine .box img {
      width: 965px;
      height: 365px;
      margin: 40px auto;
    }
    .lm-application-engine .box .content2 {
      margin: 0 auto;
      height: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #303133;
      line-height: 20px;
      text-align: center;
      font-style: normal;
    }
	}

	@media (max-width:992px) {
		.lm-application-engine .title {
			padding-top: 10px;
			margin-bottom: 15px;
		}

		.lm-application-engine .title h2 {
			font-size: 18px;
			line-height: 60px;
		}

		.lm-application-engine .title .vertical::before {
			content: '';
			display: block;
			position: absolute;
			top: 3px;
			left: -12px;
			width: 4px;
			height: 18px;
			background-color: #25A5FF;
		}

		.lm-application-engine .box {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
			margin: 0 10px;
			padding: 0;
		}

		.lm-application-engine .box .item {
			margin: 0;
			padding: 0;
		}

		.lm-application-engine .box .item .up {
			height: 60px;
			padding: 3px 10px;
			margin-bottom: 3px;
			background-color: rgba(52, 156, 227, .1);
			align-items: center;
			border-radius: 4px;
		}

		.lm-application-engine .box .item .up img {
			height: 50px;
		}

		.lm-application-engine .box .item .up h4 {
			margin: 0 0 0 5px;
		}
		.lm-application-engine .box .item p {
			margin: 0 5px;
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/LmApplicationEngine.vue